
import React from "react";
import { Classname, useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import GalleryItem from "./common/GalleryItem";
import Pagination from "./common/Pagination";
import { Utils } from "../../../../utils";
import SectionHeader from "./common/SectionHeader";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, IGallery, IProfileWebsite, OmneHostService, SanitizedResponse } from "../../../../services";

export interface GalleryProps {
    website: IProfileWebsite;
}

function Gallery({ website }: GalleryProps) {

    const labels = i18nManager.Labels.gallery;
    const omnehostService = OmneHostService.getInstance();
    const [tags, setTags] = React.useState<string[]>([]);
    const [galleryFilter, setGalleryFilter] = React.useState<string>();
    const [gallery, setGallery] = React.useState<ApiResponseData<IGallery>>();
    const { page, setPage } = useSearchParams({ defaultInit: window.location.search, params: { page: 1 } });
    const filtered = gallery?.content?.filter((g) => !galleryFilter || g.extra_data?.tags?.includes(galleryFilter));

    React.useEffect(fetchInformation, [omnehostService, page]);

    return (<section className={`${styles["section"]} ${styles["page-inner"]}`}>
        <div className={styles["container"]}>
            <SectionHeader as="h1" eyebrow={labels.eyebrow} title={labels.title} titleEm={labels.title_em} subtitle={labels.desc} />
            {tags.length > 0 && (<div className={styles["tabs"]} style={{ marginBottom: 32 }}>
                <button className={Classname.build(styles["tab"], { [styles["active"]]: !galleryFilter })} onClick={() => setGalleryFilter(undefined)}>{labels.all}</button>
                {tags.map((t) => (<button key={t} className={Classname.build(styles["tab"], { [styles["active"]]: galleryFilter === t })} onClick={() => setGalleryFilter(t)}>{t}</button>))}
            </div>)}

            {(!!filtered)
                ? ((filtered.length > 0)
                    ? (<div className={styles["gallery-grid"]}>
                        {filtered.map((g) => (<GalleryItem key={g.external_id} gallery={g} />))}
                    </div>)
                    : (Utils.emptyState()))
                : (Utils.loadingState())}

            <Pagination page={parseInt("" + page)} rowsPerPage={gallery?.size} totalRecords={gallery?.total_elements} onPageChange={setPage} />
        </div>
    </section>);

    function fetchInformation() {
        setGallery({});
        omnehostService.queryMemberGallery(website.member.username, {
            page,
            sort: "updated_at,DESC",
        }).then(({ apiResponse, content }: SanitizedResponse<IGallery>) => {
            setGallery(apiResponse.data!);
            setTags(Array.from(new Set(content?.flatMap((g) => g.extra_data?.tags ?? []) ?? [])));
        }).catch(BaseService.reportError);
    }
}

export default Gallery;
